<nav [attr.aria-label]="'GLOBAL.A11Y.SKIP_TO_MENU_LABEL' | translate" class="skip-nav" *ngIf="menuLinks.length > 0">
  <p class="skip-nav-title">{{ 'GLOBAL.A11Y.SKIP_TO_MENU_LABEL' | translate }}</p>
  <ul class="skip-nav-list">
    <li *ngFor="let link of menuLinks">
      <a [href]="'#' + link.id" (click)="handleScroll(link.id, $event)" class="skip-nav-link" role="button">
        - {{ link.label | translate }}
      </a>
    </li>
  </ul>
</nav>
